import { useCallback, useMemo } from 'react';

export const useDebugMode = () => {
  const isDebugMode = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('debugMode') === 'true';
  }, []);

  const debugLog = useCallback(
    (message: any, ...args: any[]) => {
      if (isDebugMode) {
        console.log('[ZNavDebugMode]', message, ...args);
      }
    },
    [isDebugMode],
  );

  return { debugLog };
};
